const about = {
  title: "About",
  description: `I'm a passionate B.Tech graduate in Information Technology from Chennai Institute of Technology (CGPA: 8.9). I have a strong interest in Artificial Intelligence, Machine Learning, Full-Stack Development, and Data Analytics.

With hands-on experience building innovative projects and completing internships in application development, I enjoy turning ideas into real-world solutions.

My work focuses on impactful areas such as healthcare, agritech, and gaming, where technology can create meaningful change.

I'm always open to learning, building, and collaborating on projects that solve real problems. Let's connect and explore opportunities together.`,
  resume: './MADHAN_KUMAR_M.pdf'
}

export default about